export interface TvShow {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  episodes: number;
  status: string;
  region: string;
  imageUrl: string;
  description: string;
  tags: string[];
  director: string;
  cast: string[];
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-movie-line' },
  { name: '国产剧', slug: 'guochan', icon: 'ri-flag-2-line' },
  { name: '韩剧', slug: 'hanju', icon: 'ri-kakao-talk-line' },
  { name: '美剧', slug: 'meiju', icon: 'ri-earth-line' },
  { name: '日剧', slug: 'riju', icon: 'ri-sun-line' },
  { name: '台剧', slug: 'taiju', icon: 'ri-building-2-line' },
  { name: '泰剧', slug: 'taiju-thai', icon: 'ri-ship-line' },
  { name: '动漫', slug: 'dongman', icon: 'ri-ghost-line' },
];

export const tvShows: TvShow[] = [
  {
    id: 1,
    title: '庆余年第二季',
    slug: 'qing-yu-nian-2',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 9.3,
    episodes: 36,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Qing%20Yu%20Nian%20Season%202%20Chinese%20historical%20political%20drama%20starring%20Zhang%20Ruoyun%20in%20traditional%20hanfu%20costume%2C%20dramatic%20lighting%20with%20warm%20amber%20tones%2C%20palace%20setting%20background%2C%20rich%20cinematic%20color%20grading%2C%20professional%20film%20photography%2C%20clean%20background&width=360&height=480&seq=qyn-s2-poster&orientation=portrait',
    description: '范闲在经历了一系列生死考验后，继续书写他的人生传奇。第二季中，范闲将面临更加复杂的朝堂斗争和情感纠葛，他凭借智慧和勇气，在权力与道义之间寻找平衡，最终揭开了一个个惊天秘密。',
    tags: ['古装', '权谋', '武侠', '热门'],
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    updateInfo: '全36集',
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '与凤行',
    slug: 'yu-feng-xing',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 8.9,
    episodes: 39,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Yu%20Feng%20Xing%20Chinese%20xianxia%20fantasy%20romance%20drama%20starring%20Zhao%20Liying%20in%20ethereal%20flowing%20costume%2C%20dreamy%20atmospheric%20lighting%20with%20warm%20golden%20hues%2C%20cloud%20palace%20background%2C%20romantic%20cinematic%20composition%2C%20professional%20photography&width=360&height=480&seq=yfx-poster&orientation=portrait',
    description: '灵界碧苍王沈璃为掌握自己的命运，在逃婚过程中受伤坠落人间，与下凡体验生活的上古神行止相遇。两人在人间展开了一段横跨三界、纵贯千古的绮丽虐恋。',
    tags: ['仙侠', '爱情', '古装', '热门'],
    director: '邓科',
    cast: ['赵丽颖', '林更新', '辛云来', '何与'],
    updateInfo: '全39集',
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    title: '眼泪女王',
    slug: 'tears-queen',
    category: '韩剧',
    categorySlug: 'hanju',
    year: 2024,
    rating: 9.1,
    episodes: 16,
    status: '已完结',
    region: '韩国',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Queen%20of%20Tears%20Korean%20romance%20drama%20starring%20Kim%20Soohyun%20and%20Kim%20Jiwon%2C%20emotional%20melodrama%20with%20warm%20soft%20lighting%2C%20elegant%20romantic%20composition%2C%20clean%20minimal%20background%2C%20professional%20korean%20drama%20poster%20style&width=360&height=480&seq=qot-poster&orientation=portrait',
    description: '百货女王洪海仁与超市王子白贤宇结婚三年后遭遇婚姻危机，在即将离婚之际洪海仁被诊断出绝症，两人在生命的最后时光里重新找回爱情的故事。',
    tags: ['爱情', '治愈', '剧情', '热门'],
    director: '金熙元',
    cast: ['金秀贤', '金智媛', '朴成焄', '郭东延'],
    updateInfo: '全16集',
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '繁花',
    slug: 'fan-hua',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 9.5,
    episodes: 30,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Blossoms%20Shanghai%20Fan%20Hua%20Chinese%20period%20drama%20starring%20Hu%20Ge%20in%20retro%201990s%20suit%2C%20Shanghai%20Bund%20night%20neon%20background%2C%20golden%20warm%20tone%2C%20nostalgic%20cinematic%20style%2C%20Wong%20Kar%20Wai%20aesthetic%2C%20professional%20film%20poster%20photography&width=360&height=480&seq=fanhua-poster&orientation=portrait',
    description: '九十年代的上海，阿宝凭借自己的智慧和魄力，从街头小贩一步步成为商界大亨。在改革开放的浪潮中，他经历了商场的起起落落，也见证了上海这座城市的翻天覆地。',
    tags: ['年代', '商战', '剧情', '精品'],
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    updateInfo: '全30集',
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '黑暗荣耀',
    slug: 'the-glory',
    category: '韩剧',
    categorySlug: 'hanju',
    year: 2023,
    rating: 9.2,
    episodes: 16,
    status: '已完结',
    region: '韩国',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20The%20Glory%20Korean%20revenge%20drama%20starring%20Song%20Hyekyo%2C%20dark%20moody%20atmosphere%20with%20dramatic%20shadows%2C%20intense%20gaze%20portrait%2C%20minimalist%20dark%20backdrop%2C%20professional%20korean%20drama%20poster%20style%2C%20high%20contrast%20cinematic%20lighting&width=360&height=480&seq=theglory-poster&orientation=portrait',
    description: '年少遭受校园暴力的文东恩，经过多年的精心策划，展开了一场精心设计的复仇计划。她成为了施暴者孩子的班主任，一步步瓦解那些曾经伤害过她的人的生活。',
    tags: ['复仇', '悬疑', '剧情', '热门'],
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '郑成日'],
    updateInfo: '全16集',
    isHot: false,
    isNew: false,
  },
  {
    id: 6,
    title: '三体',
    slug: 'three-body',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2023,
    rating: 8.8,
    episodes: 30,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Three%20Body%20Problem%20Chinese%20sci-fi%20drama%2C%20cosmic%20space%20background%20with%20stars%2C%20mysterious%20dark%20atmosphere%2C%20scientific%20and%20futuristic%20vibe%2C%20dramatic%20lighting%2C%20professional%20film%20poster%20photography%2C%20clean%20composition&width=360&height=480&seq=threebody-poster&orientation=portrait',
    description: '改编自刘慈欣同名科幻小说。纳米科学家汪淼被警官史强带入一个神秘组织，由此揭开了一个跨越星际文明的惊天秘密——三体文明即将入侵地球。',
    tags: ['科幻', '悬疑', '剧情', '精品'],
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    updateInfo: '全30集',
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '狂飙',
    slug: 'kuang-biao',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2023,
    rating: 9.4,
    episodes: 39,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20The%20Knockout%20Kuangbiao%20Chinese%20crime%20thriller%20drama%20starring%20Zhang%20Yi%20and%20Zhang%20Songwen%2C%20intense%20police%20versus%20gangster%20theme%2C%20dark%20noir%20style%20with%20dramatic%20contrast%2C%20urban%20night%20setting%2C%20professional%20film%20poster%20photography&width=360&height=480&seq=kuangbiao-poster&orientation=portrait',
    description: '讲述了以一线刑警安欣为代表的正义力量，与黑恶势力长达二十年的生死搏斗，通过群像叙事展现扫黑行动中的黑白较量与复杂人性。',
    tags: ['刑侦', '扫黑', '剧情', '爆款'],
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    updateInfo: '全39集',
    isHot: true,
    isNew: false,
  },
  {
    id: 8,
    title: '很想很想你',
    slug: 'miss-you-much',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 7.9,
    episodes: 33,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Miss%20You%20Much%20Chinese%20youth%20romance%20drama%2C%20sweet%20and%20warm%20atmosphere%2C%20young%20couple%20in%20urban%20setting%2C%20soft%20pastel%20warm%20lighting%2C%20romantic%20composition%2C%20professional%20drama%20poster%20photography%2C%20clean%20background&width=360&height=480&seq=missyou-poster&orientation=portrait',
    description: '顾声是一名热爱作曲的大四学生，她以"声声慢"为名在网上发布原创作品。一次偶然的机会，她与知名配音演员莫青成在游戏中相遇，一段甜蜜的爱情故事由此展开。',
    tags: ['爱情', '都市', '甜宠', '青春'],
    director: '沙维琪',
    cast: ['檀健次', '周也', '侯雯元', '杨肸子'],
    updateInfo: '全33集',
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    title: '背着善宰跑',
    slug: 'lovely-runner',
    category: '韩剧',
    categorySlug: 'hanju',
    year: 2024,
    rating: 9.0,
    episodes: 16,
    status: '已完结',
    region: '韩国',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Lovely%20Runner%20Korean%20time%20travel%20romance%20drama%2C%20youthful%20energetic%20vibe%2C%20warm%20sunny%20lighting%2C%20running%20motion%20theme%2C%20romantic%20and%20dreamy%20composition%2C%20professional%20korean%20drama%20poster%20style%2C%20clean%20background&width=360&height=480&seq=lovely-runner-poster&orientation=portrait',
    description: '为了拯救自己最爱的顶级明星柳善宰，热血粉丝任率穿越回过去的奇幻爱情故事。她用尽全力改变命运，却发现每一次穿越都带来新的变数。',
    tags: ['奇幻', '爱情', '穿越', '热门'],
    director: '尹钟浩',
    cast: ['边佑锡', '金惠奫', '宋建熙', '李承協'],
    updateInfo: '全16集',
    isHot: true,
    isNew: true,
  },
  {
    id: 10,
    title: '莲花楼',
    slug: 'lian-hua-lou',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2023,
    rating: 8.7,
    episodes: 40,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Lotus%20Tower%20Lian%20Hua%20Lou%20Chinese%20wuxia%20mystery%20drama%2C%20ancient%20Chinese%20martial%20arts%20theme%2C%20misty%20atmospheric%20background%2C%20handsome%20swordsman%20in%20traditional%20robes%2C%20dramatic%20warm%20lighting%2C%20professional%20film%20poster%20photography&width=360&height=480&seq=lianhualou-poster&orientation=portrait',
    description: '讲述了闻名武林的四顾门门主李相夷在一次大战后身受重伤，化名李莲花成为一名江湖游医，在破解一系列诡异案件的同时，也逐渐揭开了自己身上的惊天秘密。',
    tags: ['武侠', '悬疑', '古装', '探案'],
    director: '郭虎',
    cast: ['成毅', '曾舜晞', '肖顺尧', '陈都灵'],
    updateInfo: '全40集',
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '请回答1988',
    slug: 'reply-1988',
    category: '韩剧',
    categorySlug: 'hanju',
    year: 2015,
    rating: 9.7,
    episodes: 20,
    status: '已完结',
    region: '韩国',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Reply%201988%20Korean%20family%20drama%2C%20retro%201980s%20nostalgic%20vibe%2C%20group%20of%20young%20friends%20in%20vintage%20clothing%2C%20warm%20nostalgic%20tone%2C%20neighborhood%20setting%2C%20heartwarming%20composition%2C%20professional%20korean%20drama%20poster%20style&width=360&height=480&seq=reply1988-poster&orientation=portrait',
    description: '讲述了1988年在首尔双门洞居住的五家人的故事，描绘了温暖的亲情、邻里间的互助以及青涩的爱情与友情。每一集都充满了笑与泪，是韩剧史上不可逾越的经典之作。',
    tags: ['温情', '青春', '家庭', '经典'],
    director: '申源浩',
    cast: ['李惠利', '朴宝剑', '柳俊烈', '高庚杓'],
    updateInfo: '全20集',
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    title: '大江大河之岁月如歌',
    slug: 'da-jiang-da-he-3',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 8.6,
    episodes: 40,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Da%20Jiang%20Da%20He%20Season%203%20Chinese%20business%20period%20drama%2C%20reform%20and%20opening%20up%20era%20theme%2C%20industrial%20background%2C%20determined%20businessman%20portrait%2C%20golden%20warm%20tone%2C%20professional%20film%20poster%20photography%2C%20clean%20background&width=360&height=480&seq=dajiangdahe3-poster&orientation=portrait',
    description: '第三季继续讲述宋运辉、雷东宝、杨巡三人在改革开放浪潮中的奋斗历程。面对新世纪的机遇与挑战，他们各自在事业和人生道路上做出了不同的选择。',
    tags: ['年代', '商战', '剧情', '正剧'],
    director: '孔笙',
    cast: ['王凯', '杨烁', '董子健', '杨采钰'],
    updateInfo: '全40集',
    isHot: false,
    isNew: true,
  },
  {
    id: 13,
    title: '想见你',
    slug: 'someday-or-one-day',
    category: '台剧',
    categorySlug: 'taiju',
    year: 2019,
    rating: 9.2,
    episodes: 13,
    status: '已完结',
    region: '中国台湾',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Someday%20or%20One%20Day%20Taiwanese%20time%20travel%20romance%20drama%2C%20nostalgic%20cassette%20tape%20theme%2C%20warm%20retro%20atmosphere%2C%20romantic%20and%20dreamy%20composition%2C%20soft%20golden%20lighting%2C%20professional%20drama%20poster%20photography%2C%20clean%20background&width=360&height=480&seq=someday-poster&orientation=portrait',
    description: '黄雨萱在男友王诠胜空难离世两年后，收到了一盘神秘录音带。当她听着伍佰的《Last Dance》睡着后，竟然穿越回了1998年，变成了一个和自己长得一模一样的女孩——陈韵如。',
    tags: ['奇幻', '爱情', '悬疑', '穿越'],
    director: '黄天仁',
    cast: ['柯佳嬿', '许光汉', '施柏宇', '颜毓麟'],
    updateInfo: '全13集',
    isHot: false,
    isNew: false,
  },
  {
    id: 14,
    title: '长风渡',
    slug: 'chang-feng-du',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2023,
    rating: 8.5,
    episodes: 40,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Chang%20Feng%20Du%20Chinese%20historical%20romance%20drama%2C%20ancient%20Chinese%20couple%20in%20traditional%20wedding%20attire%2C%20elegant%20classical%20composition%2C%20warm%20golden%20candlelight%2C%20romantic%20atmosphere%2C%20professional%20film%20poster%20photography&width=360&height=480&seq=changfengdu-poster&orientation=portrait',
    description: '布商之女柳玉茹因缘际会嫁给了纨绔子弟顾九思，两人从互相看不顺眼到相知相守。在国家危难之际，他们携手并肩，共同守护家国天下。',
    tags: ['古装', '爱情', '家国', '成长'],
    director: '尹涛',
    cast: ['白敬亭', '宋轶', '刘学义', '张昊唯'],
    updateInfo: '全40集',
    isHot: false,
    isNew: false,
  },
  {
    id: 15,
    title: 'VIVANT',
    slug: 'vivant',
    category: '日剧',
    categorySlug: 'riju',
    year: 2023,
    rating: 8.4,
    episodes: 10,
    status: '已完结',
    region: '日本',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20VIVANT%20Japanese%20spy%20thriller%20drama%20starring%20Sakai%20Masato%2C%20international%20espionage%20theme%2C%20desert%20middle%20east%20background%2C%20intense%20action%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20japanese%20drama%20poster%20style&width=360&height=480&seq=vivant-poster&orientation=portrait',
    description: '乃木忧助是丸菱商事的优秀员工，在一次业务中被卷入巨额汇款失误事件，他前往中亚追查真相，却发现自己被卷入了一个涉及国际恐怖主义的巨大阴谋之中。',
    tags: ['悬疑', '谍战', '动作', '冒险'],
    director: '福泽克雄',
    cast: ['堺雅人', '阿部宽', '二阶堂富美', '松坂桃李'],
    updateInfo: '全10集',
    isHot: false,
    isNew: false,
  },
  {
    id: 16,
    title: '长月烬明',
    slug: 'till-the-end-of-the-moon',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2023,
    rating: 8.3,
    episodes: 40,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Till%20the%20End%20of%20the%20Moon%20Chinese%20xianxia%20fantasy%20drama%2C%20demonic%20and%20divine%20duality%20theme%2C%20dark%20versus%20light%20aesthetic%2C%20ethereal%20costume%20design%2C%20dramatic%20mystical%20lighting%2C%20professional%20film%20poster%20photography%2C%20clean%20background&width=360&height=480&seq=changyue-poster&orientation=portrait',
    description: '为了拯救被魔神澹台烬毁灭的世界，衡阳宗掌门之女黎苏苏回到了五百年前，化身为叶夕雾，试图阻止澹台烬成为魔神。然而在朝夕相处中，两人产生了意想不到的情感纠葛。',
    tags: ['仙侠', '古装', '爱情', '虐恋'],
    director: '鞠觉亮',
    cast: ['罗云熙', '白鹿', '陈都灵', '邓为'],
    updateInfo: '全40集',
    isHot: false,
    isNew: false,
  },
  {
    id: 17,
    title: '我的解放日志',
    slug: 'my-liberation-notes',
    category: '韩剧',
    categorySlug: 'hanju',
    year: 2022,
    rating: 9.1,
    episodes: 16,
    status: '已完结',
    region: '韩国',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20My%20Liberation%20Notes%20Korean%20slice%20of%20life%20drama%2C%20quiet%20suburban%20setting%2C%20introspective%20mood%2C%20three%20siblings%20theme%2C%20warm%20natural%20lighting%2C%20realistic%20and%20healing%20atmosphere%2C%20professional%20korean%20drama%20poster%20style&width=360&height=480&seq=myliberation-poster&orientation=portrait',
    description: '三兄妹厌倦了日复一日的通勤和毫无波澜的生活，他们渴望从这种"无色彩"的人生中获得解放。神秘的外地人具氏的出现，给他们的生活带来了意想不到的变化。',
    tags: ['治愈', '剧情', '人生', '写实'],
    director: '金锡允',
    cast: ['李民基', '金智媛', '孙锡久', '李艾儿'],
    updateInfo: '全16集',
    isHot: false,
    isNew: false,
  },
  {
    id: 18,
    title: '猎冰',
    slug: 'lie-bing',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 8.1,
    episodes: 18,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Lie%20Bing%20Chinese%20anti%20drug%20crime%20thriller%20drama%2C%20police%20operation%20theme%2C%20intense%20action%20atmosphere%2C%20dark%20noir%20style%2C%20urban%20night%20setting%2C%20dramatic%20contrast%20lighting%2C%20professional%20film%20poster%20photography&width=360&height=480&seq=liebing-poster&orientation=portrait',
    description: '以缉毒警察赵友男为代表的缉毒团队，在追捕大毒枭黄宗伟的过程中，展开了一场惊心动魄的禁毒斗争。故事紧张刺激，真实还原了一线缉毒警察的危险与坚守。',
    tags: ['刑侦', '缉毒', '动作', '悬疑'],
    director: '高群书',
    cast: ['张颂文', '姚安娜', '韩庚', '包文婧'],
    updateInfo: '全18集',
    isHot: false,
    isNew: true,
  },
  {
    id: 19,
    title: '玫瑰的故事',
    slug: 'the-tale-of-rose',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 8.2,
    episodes: 38,
    status: '连载中',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20The%20Tale%20of%20Rose%20Chinese%20female%20growth%20drama%20starring%20Liu%20Yifei%2C%20elegant%20feminine%20portrait%2C%20rose%20motif%20theme%2C%20soft%20warm%20lighting%2C%20romantic%20and%20sophisticated%20composition%2C%20professional%20film%20poster%20photography%2C%20clean%20background&width=360&height=480&seq=taleofrose-poster&orientation=portrait',
    description: '黄亦玫出身书香门第，从小在呵护中长大。在经历了几段感情挫折后，她不断成长与蜕变，最终找到了真正的自我。一段跨越二十年的女性成长史诗。',
    tags: ['都市', '爱情', '女性', '成长'],
    director: '汪俊',
    cast: ['刘亦菲', '佟大为', '林更新', '万茜'],
    updateInfo: '更新至32集',
    isHot: true,
    isNew: true,
  },
  {
    id: 20,
    title: '不良执念清除师',
    slug: 'oh-no-here-comes-trouble',
    category: '台剧',
    categorySlug: 'taiju',
    year: 2023,
    rating: 8.8,
    episodes: 12,
    status: '已完结',
    region: '中国台湾',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Oh%20No%20Here%20Comes%20Trouble%20Taiwanese%20supernatural%20comedy%20drama%2C%20ghost%20and%20calligraphy%20theme%2C%20quirky%20dark%20comedy%20vibe%2C%20young%20cast%20ensemble%2C%20mysterious%20yet%20playful%20atmosphere%2C%20professional%20drama%20poster%20photography&width=360&height=480&seq=buliang-poster&orientation=portrait',
    description: '高中生蒲一永在一次车祸后获得了看见鬼魂"执念"的能力，他与女警陈楮英以及死对头曹光砚组成了"执念清除小队"，帮助鬼魂们了结心愿，也在这个过程中重新认识了自己的家人。',
    tags: ['奇幻', '喜剧', '治愈', '悬疑'],
    director: '林冠慧',
    cast: ['曾敬骅', '宋芸桦', '彭千祐', '杨谨华'],
    updateInfo: '全12集',
    isHot: false,
    isNew: false,
  },
  {
    id: 21,
    title: '仙剑六祈今朝',
    slug: 'sword-fairy-6',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 7.8,
    episodes: 40,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Sword%20and%20Fairy%206%20Chinese%20xianxia%20fantasy%20drama%2C%20magical%20martial%20arts%20theme%2C%20ethereal%20costume%20design%2C%20mystical%20landscape%20background%2C%20dreamy%20atmospheric%20lighting%2C%20professional%20film%20poster%20photography%2C%20clean%20composition&width=360&height=480&seq=xianjian6-poster&orientation=portrait',
    description: '越今朝和越祈在乌岩村相伴三年，有着神奇的"共鸣"关系。他们携手行走江湖，卷入了一场涉及人神两界的巨大阴谋之中，也逐步揭开了两人身世之谜。',
    tags: ['仙侠', '古装', '奇幻', '冒险'],
    director: '刘国楠',
    cast: ['许凯', '虞书欣', '付辛博', '万鹏'],
    updateInfo: '全40集',
    isHot: false,
    isNew: true,
  },
  {
    id: 22,
    title: '重启人生',
    slug: 'brush-up-life',
    category: '日剧',
    categorySlug: 'riju',
    year: 2023,
    rating: 9.0,
    episodes: 10,
    status: '已完结',
    region: '日本',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Brush%20Up%20Life%20Japanese%20fantasy%20comedy%20drama%2C%20reincarnation%20theme%2C%20everyday%20life%20setting%2C%20quirky%20and%20warm%20atmosphere%2C%20natural%20lighting%2C%20professional%20japanese%20drama%20poster%20style%2C%20clean%20background&width=360&height=480&seq=brushuplife-poster&orientation=portrait',
    description: '33岁的近藤麻美意外去世后获得了重生的机会。为了来世能投胎为人，她开始了一段段积累功德的人生。在一次次重生中，她逐渐发现了生命中真正重要的东西。',
    tags: ['奇幻', '喜剧', '治愈', '人生'],
    director: '水野格',
    cast: ['安藤樱', '夏帆', '木南晴夏', '松坂桃李'],
    updateInfo: '全10集',
    isHot: false,
    isNew: false,
  },
  {
    id: 23,
    title: '承欢记',
    slug: 'cheng-huan-ji',
    category: '国产剧',
    categorySlug: 'guochan',
    year: 2024,
    rating: 7.8,
    episodes: 37,
    status: '已完结',
    region: '中国大陆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Cheng%20Huan%20Ji%20Chinese%20urban%20family%20drama%2C%20mother%20daughter%20relationship%20theme%2C%20modern%20Shanghai%20setting%2C%20warm%20realistic%20atmosphere%2C%20soft%20natural%20lighting%2C%20professional%20film%20poster%20photography%2C%20clean%20background&width=360&height=480&seq=chenghuanji-poster&orientation=portrait',
    description: '出身于上海普通人家的麦承欢，在母亲的催促下与男友辛家亮议婚。然而辛家的优渥条件让麦家母女关系变得紧张，承欢在亲情与爱情之间做出了艰难的抉择。',
    tags: ['都市', '家庭', '爱情', '现实主义'],
    director: '田宇',
    cast: ['杨紫', '许凯', '牛骏峰', '许龄月'],
    updateInfo: '全37集',
    isHot: false,
    isNew: true,
  },
  {
    id: 24,
    title: '财阀家的小儿子',
    slug: 'reborn-rich',
    category: '韩剧',
    categorySlug: 'hanju',
    year: 2022,
    rating: 8.6,
    episodes: 16,
    status: '已完结',
    region: '韩国',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20Reborn%20Rich%20Korean%20business%20revenge%20drama%20starring%20Song%20Joongki%2C%20chaebol%20corporate%20theme%2C%20luxurious%20and%20dramatic%20atmosphere%2C%20power%20struggle%20vibe%2C%20professional%20korean%20drama%20poster%20style%2C%20clean%20sophisticated%20background&width=360&height=480&seq=rebornrich-poster&orientation=portrait',
    description: '忠心耿耿的尹贤宇被财阀顺阳集团诬陷杀害后，竟然重生为顺阳家族最受宠爱的小孙子陈导俊。他利用前世记忆，开始了一场对顺阳集团的复仇与夺权之战。',
    tags: ['重生', '商战', '复仇', '爽剧'],
    director: '郑大允',
    cast: ['宋仲基', '李星民', '申铉彬', '赵汉哲'],
    updateInfo: '全16集',
    isHot: false,
    isNew: false,
  },
];

export const homeBannerData = [
  {
    id: 1,
    title: '庆余年第二季',
    subtitle: '范闲归来，再续传奇',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20scene%20of%20Qing%20Yu%20Nian%20Season%202%20Chinese%20TV%20drama%2C%20dramatic%20lighting%2C%20rich%20warm%20amber%20tones%2C%20artistic%20composition%2C%20moody%20atmosphere%2C%20cinematic%20color%20grading%2C%20dark%20background%20with%20warm%20highlights%2C%20professional%20film%20photography%2C%20palace%20setting&width=1920&height=1080&seq=banner-qyn2&orientation=landscape',
    link: '/article/1',
  },
  {
    id: 2,
    title: '狂飙',
    subtitle: '二十年黑白较量，正义永不缺席',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20scene%20of%20The%20Knockout%20Kuangbiao%20Chinese%20crime%20drama%2C%20dramatic%20noir%20lighting%2C%20police%20versus%20gangster%20theme%2C%20intense%20moody%20atmosphere%2C%20urban%20night%20setting%2C%20cinematic%20color%20grading%2C%20professional%20film%20photography&width=1920&height=1080&seq=banner-kuangbiao&orientation=landscape',
    link: '/article/7',
  },
  {
    id: 3,
    title: '繁花',
    subtitle: '九十年代的上海，一座城的黄金时代',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20scene%20of%20Blossoms%20Shanghai%20Fan%20Hua%20Chinese%20drama%2C%20retro%201990s%20Shanghai%20Bund%20at%20night%2C%20golden%20warm%20neon%20lights%2C%20nostalgic%20atmosphere%2C%20Wong%20Kar%20Wai%20aesthetic%2C%20cinematic%20color%20grading%2C%20professional%20film%20photography&width=1920&height=1080&seq=banner-fanhua&orientation=landscape',
    link: '/article/4',
  },
  {
    id: 4,
    title: '背着善宰跑',
    subtitle: '为了拯救你，我穿越时光而来',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20scene%20of%20Lovely%20Runner%20Korean%20romance%20drama%2C%20dreamy%20time%20travel%20theme%2C%20warm%20sunny%20lighting%2C%20romantic%20atmosphere%2C%20youthful%20energetic%20vibe%2C%20cinematic%20color%20grading%2C%20professional%20Korean%20drama%20photography&width=1920&height=1080&seq=banner-lovely-runner&orientation=landscape',
    link: '/article/9',
  },
];

export const rankingShows = tvShows.slice().sort((a, b) => b.rating - a.rating).slice(0, 10);